










































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import BTableColumn from "@/models/base/BTableColumn.model";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import Persona from "@/models/persona/persona.model";
import moment from "moment";
import Usuario from "@/models/usuarios/usuario.model";
import fileService, { getDocumentDownloadErrorMessage } from "@/services/file.service";
@Component
export default class TramiteBeneficiarioTableComponent extends GenericBTable<
  TramiteBeneficiario
> {
  @Prop() public title!: string;
  @Prop() public controller!: string;
  @Prop() public action!: string;
  @Prop() public personaId!: string;
  @Prop() public noInit!: boolean;
  created() {
    this.setupTable();
  }
  get isMobile() {
    return this.$store.state.isMobile;
  }
  getPersona(id: number, nombre: string, cedula: string, foto: string) {
    let persona = new Persona();
    persona.id = id;
    persona.nombreCompleto = nombre;
    persona.cedula = cedula;
    persona.foto = foto;
    return persona;
  }
  setupTable() {
    this.tableConfig.controller = this.controller || "tramitebeneficiario";
    //this.tableConfig.loading = false;
    this.tableConfig.whereParams = this.getWhereParams();
    this.tableConfig.resource = "consulta-perfil-ciudadano";
    //this.tableConfig.activeActions = false;
    this.tableConfig.actions.customTemplate = true;
    this.tableConfig.loadOnMount = !this.noInit || !!this.personaId;
    this.tableConfig.enableDefaultColumns = false;
    this.tableConfig.include = this.includes;
    this.tableConfig.detailed = true;
    this.formatColumns();
  }

  get includes() {
    let data = [];
    data.push(
      "Estado",
      "TipoTramite",
      "Beneficiario.Persona",
      "Persona",
      "Asignado.Persona"
    );
    return data.join("|");
  }
  formatColumns() {
    let nut = new BTableColumn("numeroTramite", "NUT");
    let estado = new BTableColumn("estado.descripcion", "Estado");
    estado.customTemplate = true;
    estado.templateSlot = "estado";
    let tipo = new BTableColumn("tipoTramite.nombre", "Tipo");
    let beneficiario = new BTableColumn(
      "beneficiarioNombre",
      "Beneficiario",
      false
    );
    beneficiario.customTemplate = true;
    let solicitante = new BTableColumn("personaNombre", "Solicitante", false);
    solicitante.customTemplate = true;
    let usuario = new BTableColumn("asignadoId", "Representante");
    usuario.customTemplate = true;
    usuario.templateSlot = "usuario";
    let updatedDate = new BTableColumn("updatedDate", "Actualización");
    updatedDate.type = BTableColumnType.DateTime;
    //let actions = new BTableColumn("customActions", "Acciones", false);
    //actions.customTemplate = true;
    this.tableConfig.insertColumns(
      nut,
      estado,
      tipo,
     // beneficiario,
      solicitante,
     // usuario,
      updatedDate
      // actions
    );
  }
  async descargarComprobante(id: number) {
    try {
      await fileService.openAuthenticatedPdf(`TramiteBeneficiario/Comprobante/${id}`);
    } catch (error) {
      this.operationFailed(getDocumentDownloadErrorMessage(error));
    }
  }
  getUsuario(row: any) {
    let usuario = new Usuario();
    usuario.id = row.asignadoId;
    usuario.imagenPerfil = row.asignadoImagenPerfil;
    usuario.userName = row.asignadoUserName;
    usuario.email = row.asignadoUserEmail;
    return usuario;
  }
  @Watch("personaId", { immediate: true })
  onPersonaIdChange(value: number | undefined | null) {
    if (!value) {
      return;
    }
   this.search();
  }
  review(id: number) {
    this.$router.push(`/resumen-solicitud/${id}`);
  }
  getEstadoColor(codigo: string) {
    if (codigo === "Abierto") return "white";
    if (codigo === "Creado") return "primary";
    if (codigo === "En proceso") return "info";
    if (codigo === "Cerrado") return "dark";
    if (codigo === "Completado") return "success";
    if (codigo === "Rechazado") return "danger";
  }
  getValueDate(val: any) {
    return moment(val).format("L");
  }
  getValueTime(val: string) {
    return moment(val).format("LT");
  }
  verNota(row: TramiteBeneficiario) {
    if (row.motivoRechazo)
      this.$buefy.dialog.alert({
        title: "Motivo de rechzo",
        message: row.motivoRechazo,
        type: "is-danger",
        hasIcon: true,
        icon: "times-circle",
        iconPack: "fa"
      });
  }
  userId: number | null = null;
  isUserModalActive: boolean = false;
  onUser(userId: number) {
    this.userId = userId;
    this.isUserModalActive = true;
  }
  filterEstadoId: any = 0;
  searchText = "";
  getWhereParams() {
    let result = [];
    if (this.personaId)
      result.push(
        `(personaId="${this.personaId}" || Beneficiario.personaId="${this.personaId}")`
      );
    let firts = result.join("&");

    if (this.filterEstadoId){
     firts = `${firts} && estadoId="${this.filterEstadoId}"`;
    };
    if (this.searchText)
      return `${firts} && numeroTramite.Contains("${this.searchText}")`;
    return firts;
  }
  search() {
    this.tableConfig.whereParams = this.getWhereParams();
    if (this.tableConfig.reload) this.tableConfig.reload();
  }
}
